import React from "react";
import { Container, Typography, List, ListItem, ListItemText, Divider } from "@mui/material";

const About = () => {
  return (
    <Container maxWidth="md" sx={{ mt: 5 }}>
      {/* Titolo principale */}
      <Typography variant="h4" gutterBottom align="center">
        <strong>Chi sono </strong>
      </Typography>

      {/* Storia personale */}
      <Typography variant="body1" paragraph>
      Mi chiamo <strong>Andrea Ricci</strong> e da sempre nutro una profonda curiosità per la tecnologia. Fin da piccolo, il mio interesse per l’informatica è nato giocando ai videogiochi e cercando di capire cosa si celasse dietro il loro funzionamento. Col tempo, questa passione si è trasformata in un percorso concreto nello sviluppo software, spingendomi a studiare diversi linguaggi di programmazione e a esplorare le tecnologie più innovative.

      </Typography>

      <Typography variant="body1" paragraph>
      Tuttavia, per me l’informatica non è solo codice e algoritmi, ma un potente strumento per migliorare la vita delle persone. Credo fermamente che la tecnologia debba essere accessibile a tutti, indipendentemente dalle loro competenze o dal contesto in cui si trovano. Questa visione è stata rafforzata dalle mie esperienze nel sociale e nel volontariato, dove ho potuto vedere da vicino come la mancanza di accesso alle competenze digitali possa rappresentare un ostacolo per molte persone.
      </Typography>

      <Typography variant="body1" paragraph>
      Il mio obiettivo è contribuire a rendere l’informatica più inclusiva, sviluppando soluzioni intuitive e condividendo le mie conoscenze con chi desidera avvicinarsi a questo mondo. Inoltre, la mia buona conoscenza della lingua inglese mi permette di approfondire continuamente nuove tecnologie, accedere a risorse globali e collaborare con professionisti di tutto il mondo.




      </Typography>
      <Typography variant="body1" paragraph>
      Sono spinto dalla voglia di innovare, imparare continuamente e mettere le mie competenze al servizio di un futuro in cui la tecnologia sia davvero alla portata di tutti.




      </Typography>
    

      {/* Divider per separare la sezione */}
      <Divider sx={{ my: 3 }} />

      {/* Hard Skills */}
      <Typography variant="h5" gutterBottom>
        Hard Skills
    </Typography>
<List>
  <ListItem>
    <ListItemText primary="🔹 Linguaggi di programmazione: Java, JavaScript, Python, C#, SQL" />
  </ListItem>
  <ListItem>
    <ListItemText primary="🔹 Framework: Spring Boot, .NET Core, React, Flask, Django" />
  </ListItem>
  <ListItem>
    <ListItemText primary="🔹 Database: MySQL, PostgreSQL" />
  </ListItem>
  <ListItem>
    <ListItemText primary="🔹 Cloud Computing: Azure, AWS (base)" />
  </ListItem>
  <ListItem>
    <ListItemText primary="🔹 DevOps & Ambienti: Docker, utilizzo di macchine virtuali (VM), ambienti Linux/Unix" />
  </ListItem>
  <ListItem>
    <ListItemText primary="🔹 Shell & Sistemi: Bash, gestione file system e comandi Unix/Linux" />
  </ListItem>
  <ListItem>
    <ListItemText primary="🔹 Git & Version Control: GitHub, GitHub Desktop, SourceTree, GitKraken" />
  </ListItem>
  <ListItem>
    <ListItemText primary="🔹 API e Integrazioni: REST API, WebSocket" />
  </ListItem>
</List>


      {/* Divider */}
      <Divider sx={{ my: 3 }} />

      {/* Soft Skills */}
      <Typography variant="h5" gutterBottom>
        Soft Skills
      </Typography>
      <List>
        <ListItem>
          <ListItemText primary="🔹 Problem Solving" />
        </ListItem>
        <ListItem>
          <ListItemText primary="🔹 Adattabilità e apprendimento continuo" />
        </ListItem>
        <ListItem>
          <ListItemText primary="🔹 Lavoro di squadra e collaborazione" />
        </ListItem>
        <ListItem>
          <ListItemText primary="🔹 Pensiero critico e analitico" />
        </ListItem>
        <ListItem>
          <ListItemText primary="🔹 Gestione del tempo e organizzazione" />
        </ListItem>
        <ListItem>
          <ListItemText primary="🔹 Comunicazione efficace" />
        </ListItem>
      </List>
    </Container>
  );
};

export default About;
